import React, { useState } from "react";
import DateInputWithIcon from "./DateInputWithIcon"; // Pastikan path ini sesuai

// const DateRangePicker = ({ value, onChange }) => {
//   const [dateRange, setDateRange] = useState({
//     startDate: value?.startDate || "",
//     endDate: value?.endDate || "",
//   });

//   const handleDateChange = (field, newValue) => {
//     const newDateRange = { ...dateRange, [field]: newValue };

//     // Pastikan endDate tidak lebih kecil dari startDate
//     if (field === "startDate" && newDateRange.endDate && newValue > newDateRange.endDate) {
//       newDateRange.endDate = newValue;
//     }

//     setDateRange(newDateRange);
//     onChange?.(newDateRange); // Kirim data ke parent jika onChange ada
//   };

//   return (
//     <div className="d-flex gap-2">
//       <div className="flex-grow-1">
//         <label className="form-label">Start Date</label>
//         <DateInputWithIcon
//           value={dateRange.startDate}
//           onChange={(value) => handleDateChange("startDate", value)}
//         />
//       </div>
//       <div className="flex-grow-1">
//         <label className="form-label">End Date</label>
//         <DateInputWithIcon
//           value={dateRange.endDate}
//           onChange={(value) => handleDateChange("endDate", value)}
//         />
//       </div>
//     </div>
//   );
// };

const DateRangePicker = ({ value, onChange }) => {
  const [dateRange, setDateRange] = useState({
    startDate: value?.startDate || "",
    endDate: value?.endDate || "",
  });

  const handleDateChange = (field, newValue) => {
    const newDateRange = { ...dateRange, [field]: newValue };

    // Pastikan `endDate` tidak lebih kecil dari `startDate`
    if (field === "startDate" && newDateRange.endDate && newValue > newDateRange.endDate) {
      newDateRange.endDate = newValue;
    }

    setDateRange(newDateRange);
    onChange?.(newDateRange); // Kirim perubahan ke parent
  };

  return (
    <div className="d-flex gap-2">
      <div className="flex-grow-1">
        <label className="form-label">Start Date</label>
        <DateInputWithIcon
          value={dateRange.startDate}
          onChange={(value) => handleDateChange("startDate", value)}
        />
      </div>
      <div className="flex-grow-1">
        <label className="form-label">End Date</label>
        <DateInputWithIcon
          value={dateRange.endDate}
          onChange={(value) => handleDateChange("endDate", value)}
        />
      </div>
    </div>
  );
};


export default DateRangePicker;
